var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme'; // import { SiteHeaderMenuItem, classNames } from '@shapeable/web';

import { NavigationMenuItem } from './navigation-menu-item';
import { classNames } from '../../utils/cn';
var cls = classNames('navigation-menu');
export var NavigationMenuDefaultProps = {
  items: []
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: pointer;\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    cursor: pointer;\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var ChildrenStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n  "], ["\n    margin: 0;\n    padding: 0;\n  "])))
});
var ChildStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    cursor: pointer;\n    a {\n      padding-left: ", ";\n    }\n  "], ["\n    cursor: pointer;\n    a {\n      padding-left: ", ";\n    }\n  "])), theme.UNIT(7))
}); // -------- Components -------->

var My = {
  Container: styled.ul(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(NavigationMenuItem)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Children: styled.ul.attrs(cls.attr('item-children'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ChildrenStyles),
  Child: styled(NavigationMenuItem)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ChildStyles)
};
export var NavigationMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
      items = props.items,
      onItemClick = props.onItemClick;
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, items.map(function (item) {
    var _a;

    var href = item.url || item.path || ((_a = item.page) === null || _a === void 0 ? void 0 : _a.path);
    return React.createElement(My.Item, {
      entity: item,
      isInverted: true,
      onClick: function onClick() {
        onItemClick(item);
      },
      key: item.id,
      icon: item.__icon,
      href: item.hasChildren ? undefined : href,
      isActive: item.isActive,
      label: item.name
    }, item.isDisclosed && React.createElement(My.Children, null, item.children.map(function (child) {
      var _a;

      var childHref = child.url || child.path || ((_a = child.page) === null || _a === void 0 ? void 0 : _a.path);
      return React.createElement(My.Child, {
        entity: child,
        isInverted: true,
        onClick: function onClick() {
          onItemClick(child);
        },
        key: child.id,
        icon: child.__icon,
        href: childHref,
        isActive: child.isActive,
        label: child.name
      });
    })));
  }));
});
/* @ts-ignore */

NavigationMenu.cls = cls;
NavigationMenu.defaultProps = NavigationMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;